import { Pipe, PipeTransform } from "@angular/core";
import { ExternalNotificationStateKindEnum } from "./external-notification.model";

@Pipe({
  name: "driverNotification",
})
export class DriverNotificationPipe implements PipeTransform {
  transform(value: any, args?: any): any {
    const res = value.filter((f) => f.NotificationState !== ExternalNotificationStateKindEnum.Seen).length;
    return res;
  }
}
